/** Kiddoware admin / subscription console (prod). */
export const KIDDOWARE_ACCOUNT_URL = 'https://app.kiddoware.com';

/** Product IDs that unlock Explore supervised web search. */
export const SEARCH_LICENSE_PRODUCT_IDS = ['kw', 'kpsb'];

export const SEARCH_LICENSE_PRODUCT_LABELS = {
  kw: 'Kiddoware',
  kpsb: 'Kids Place Safe Browser',
};

export const SEARCH_LICENSE_UPGRADE_HINT =
  'Supervised web search requires an active Kiddoware or Kids Place Safe Browser license.';

/**
 * @param {string} [idToken] Firebase ID token for one-click sign-in to the account console.
 */
export function getKiddowareAccountUrl(idToken) {
  if (idToken) {
    return `${KIDDOWARE_ACCOUNT_URL}/login#idToken=${encodeURIComponent(idToken)}`;
  }
  return KIDDOWARE_ACCOUNT_URL;
}
